<template>
  <div
    v-if="message"
    class="bg-red-lighter p-2 w-full"
  >
    <p class="text-red font-semibold text-sm">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>
